<section class="flex-column full-height">
  <vdw-tabs-menu-card
    [icon]="isEditingMaterialSet() ? 'details-blue' : 'add-blue'"
    [action]="getTabAction()"
    [title]="generalForm.value.name"
    [isInUse]="showInUseUnableToSave()"
    [invalidFormMessageError]="canShowInvalidFormMessageError()"
    [isLoading]="canShowSkeletonView()"
    [hasPermissionToEdit]="hasPermissionToEditMaterialSet()"
    [isCreateNewPage]="!isEditingMaterialSet()"
    [saving]="saving"
    [identifier]="headerIdentifier"
    [menuItems]="menuItems"
    [selectedMenuItem]="selectedMenuItem"
    (selectedMenuItemChange)="onSelectedMenuItemChange($event)"
    (backEvent)="navigateBack()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="saveMaterialSet(SAVE_TYPE.SAVE)"
    (saveAndCloseEvent)="saveMaterialSet(SAVE_TYPE.SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="saveMaterialSet(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (deleteEvent)="deleteMeterialSet()"
    (duplicateEvent)="duplicateMeterialSet()"
    (inUseEvent)="openConflictsDialog()"
    (settingsEvent)="navigateToCustomSettings()"
  >
  </vdw-tabs-menu-card>

  <div
    class="flex-row gap-16 full-height overflow-auto"
    vdwBp.lt-sm="flex-column"
    [class.full-max-height-with-toolbar]="isMaterialSetOfTypeYarnSet()"
    [class.tab-height]="isMaterialSetOfTypeColorSet()"
  >
    @if (!showAlternativeSetsTab()) {
      <mat-card
        appearance="outlined"
        class="skeleton-wrapper no-margin overflow-auto one-third-width full-width-mobile"
        [class.skeleton]="canShowSkeletonView()"
        [@fadeIn]="canShowSkeletonView()"
        [vdwBp.lt-md]="{'optional-settings': showOptionalSettingsTab()}"
      >
        @if (!showOptionalSettingsTab() && !showAlternativeSetsTab()) {
          <mat-card-content>
            @if (canShowGeneralForm()) {
              <article class="flex-column gap-16">
                <h4>{{ 'TEXTILE_DATA.MATERIAL_SET.CREEL_POSITION' | bmsTranslate: {count: 1, position: ''} }}</h4>
                <fieldset [formGroup]="generalForm" [disabled]="!canEditMaterialSet()" appBreadcrumbFormLinker>
                  <section class="flex-row gap-16 overflow-auto">
                    <div class="form-field-skeleton-wrapper">
                      <mat-form-field class="full-width">
                        <mat-label>{{ 'GENERAL.NAME' | bmsTranslate }}</mat-label>
                        <input matInput type="text" formControlName="name" (change)="onMaterialSetNameChange()" />
                        @if (canShowSuggestionForMaterialSetName()) {
                          <mat-hint class="flex-row">
                            <vdw-ellipsis-label class="overflow-hidden" [text]="'GENERAL.SUGGESTION' | bmsTranslate: {value: suggestedMaterialSetName}" matTooltipPosition="below"></vdw-ellipsis-label>
                            <a class="url" (mousedown)="applySuggestionForMaterialSetName()">{{ 'GENERAL.ACTIONS.APPLY' | bmsTranslate }}</a>
                          </mat-hint>
                        }
                        <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'required'">
                          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                        </mat-error>
                        <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'">
                          {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
                          <a class="url" [routerLink]="getLoadLink()">{{ 'GENERAL.ACTIONS.LOAD' | bmsTranslate }}</a>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    @if (canSelectCreelPosition()) {
                      <div class="flex-end-center">
                        <div class="button-skeleton-wrapper raised-btn">
                          <mat-checkbox appDataCy="select-all-positions-checkbox" [checked]="isMaterialSetSelected()" (change)="selectAllCreelPositions($event)" color="primary">
                            {{ 'TEXTILE_DATA.MATERIAL_SET.SELECT_ALL_POSITIONS' | bmsTranslate }}
                          </mat-checkbox>
                        </div>
                      </div>
                    }
                  </section>
                  @if (canShowCreelPositionsInput()) {
                    <section class="flex-row creel-position">
                      <mat-form-field>
                        <mat-label>{{ 'TEXTILE_DATA.MATERIAL_SET.CREEL_POSITION' | bmsTranslate: {count: 2, position: ''} }}</mat-label>
                        <input matInput vdwL10nDecimal type="number" formControlName="creelPositions" />
                        <mat-error *vdwCanShowErrorForFormControl="'creelPositions'; error: 'required'">
                          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
                        </mat-error>
                        <mat-error *vdwCanShowErrorForFormControl="'creelPositions'; error: 'min'">
                          {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: '1'} }}
                        </mat-error>
                        <mat-error *vdwCanShowErrorForFormControl="'creelPositions'; error: 'max'">
                          {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: '32'} }}
                        </mat-error>
                      </mat-form-field>

                      <button
                        appDataCy="add-creel-positions"
                        mat-flat-button
                        [disabled]="!canAddCreelPositions()"
                        (click)="addCreelPositions()"
                        class="add-creel-positions-btn"
                        type="button"
                        [ngClass]="{
                          'ng-invalid': canShowInvalidFormMessageError(),
                          invalid: canShowInvalidFormMessageError()
                        }"
                      >
                        {{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'TEXTILE_DATA.MATERIAL_SET.CREEL_POSITION' | bmsTranslate: {count: 2, position: ''} | lowercase} }}
                      </button>
                    </section>
                  }
                  <app-creel-positions
                    [materialSet]="materialSet"
                    [canShowErrorForCreelPosition]="canShowErrorForCreelPositionIndex.bind(this)"
                    [canEditMaterialSet]="canEditMaterialSet()"
                    (selectedCreelPositionChanged)="selectedCreelPositionChanged()"
                    (creelPositionHasBeenChanged)="creelPositionHasBeenChanged()"
                  >
                  </app-creel-positions>
                </fieldset>
              </article>
            }
          </mat-card-content>
        }

        @if (showOptionalSettingsTab()) {
          <mat-card-content>
            <article class="flex-row">
              <form [formGroup]="additionalOptionsForAddColorSetForm" class="flex-column full-width">
                <fieldset [disabled]="!canEditMaterialSet()">
                  <mat-form-field class="full-width">
                    <mat-label>{{ 'GENERAL.TECHNICAL_CODE' | bmsTranslate }}</mat-label>
                    <input matInput type="text" formControlName="technicalCode" />
                  </mat-form-field>
                </fieldset>
              </form>
            </article>
          </mat-card-content>
        }
      </mat-card>
    }

    @if (showAlternativeSetsTab()) {
      <mat-card appearance="outlined" class="skeleton-wrapper no-margin overflow-auto full-width full-width-mobile" [class.skeleton]="canShowSkeletonView()" [@fadeIn]="canShowSkeletonView()">
        <mat-card-header class="flex-start-center">
          <mat-card-title class="antialiased">
            <div class="flex-column full-width header-title">
              <h4 class="font-weight-semibold title">{{ 'TEXTILE_DATA.COLOR_SET.SELECT_ALTERNATIVE_COLOR_SET' | bmsTranslate }}</h4>
            </div>
          </mat-card-title>
          <div class="flex-end-center flex-0 gap-16 full-width">
            <mat-slide-toggle class="flex-center-center selected-toggle" (change)="showSelected($event)">{{ 'GENERAL.SELECTED' | bmsTranslate }}</mat-slide-toggle>
          </div>
        </mat-card-header>
        <mat-card-content class="flex-column color-sets-mat-card-content full-height">
          @if (canShowListOfColorSets()) {
            <ag-grid-angular class="ag-theme-vdw" [gridOptions]="gridOptionsForColorSets" [rowData]="listOfColorSets"></ag-grid-angular>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (showSelectionCard()) {
      @if (canShowSelectColor()) {
        <app-select-color
          #selectColorComponent
          class="one-third-width full-width-mobile"
          (creelPositionHasBeenChanged)="creelPositionHasBeenChanged()"
          [creelPositions]="getSelectedCreelPositions()"
        ></app-select-color>
      }
      @if (canShowSelectYarnType()) {
        <app-select-yarn-type
          #selectYarnTypeComponent
          class="one-third-width full-width-mobile"
          (creelPositionHasBeenChanged)="creelPositionHasBeenChanged()"
          [creelPositions]="getSelectedCreelPositions()"
        ></app-select-yarn-type>
      }
    }

    @if (!showOptionalSettingsTab() && !showAlternativeSetsTab() && canShowCreelPositionDetails()) {
      <div class="one-third-width full-width-mobile">
        <app-creel-position-details
          [materialSet]="materialSet"
          [creelPosition]="getSelectedCreelPosition()"
          [canShowError]="canShowErrorForSelectedCreelPosition()"
          [canEditMaterialSet]="canEditMaterialSet()"
          (creelPositionHasBeenChanged)="creelPositionHasBeenChanged()"
        ></app-creel-position-details>
      </div>
    }
  </div>
</section>
